var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9277 6.75V17.25C21.9277 17.8467 21.6907 18.419 21.2687 18.841C20.8468 19.2629 20.2745 19.5 19.6777 19.5H4.67773C4.081 19.5 3.5087 19.2629 3.08674 18.841C2.66479 18.419 2.42773 17.8467 2.42773 17.25V6.75M21.9277 6.75C21.9277 6.15326 21.6907 5.58097 21.2687 5.15901C20.8468 4.73705 20.2745 4.5 19.6777 4.5H4.67773C4.081 4.5 3.5087 4.73705 3.08674 5.15901C2.66479 5.58097 2.42773 6.15326 2.42773 6.75M21.9277 6.75V6.993C21.9278 7.37715 21.8295 7.75491 21.6422 8.0903C21.4549 8.42569 21.1848 8.70754 20.8577 8.909L13.3577 13.524C13.0029 13.7425 12.5944 13.8582 12.1777 13.8582C11.761 13.8582 11.3525 13.7425 10.9977 13.524L3.49773 8.91C3.17066 8.70854 2.9006 8.42669 2.7133 8.0913C2.526 7.75591 2.42769 7.37815 2.42773 6.994V6.75",
    stroke: "#001E1D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.3aa1bd0084ed180c83860559c5d17c3f.svg";
export { ForwardRef as ReactComponent };